import OrderRequest from '../../../../../../../../types/api/order-request'
import renderDatetime from '../../../../../../../../helpers/tables/render-datetime'
import { ColumnsType } from 'antd/es/table'
import { requiredInputNumberRules } from '../../../../../../../../constants/forms/validation/rules'
import { Form, InputNumber } from 'antd'


export const columns: ColumnsType<OrderRequest> = [
    {
        title: 'Дата создания',
        dataIndex: 'createdAt',
        width: 100,
        render: (v: string) => {
            return v ? renderDatetime(v) : undefined
        },
    },
    {
        title: 'Статус',
        dataIndex: 'requestStatus',
        width: 70,
    },
    {
        title: 'Инициатор',
        dataIndex: ['initiator', 'username'],
        width: 110,
    },
    {
        title: 'Кол-во',
        dataIndex: 'amount',
        width: 70,
        render: (value, record) => {
            const unitName = record.unit ? record.unit.shortName : ''
            return (
                <Form.Item
                    name={['amounts', record.documentId]}
                    rules={requiredInputNumberRules}
                    style={{ marginBottom: 0, display: 'flex', alignItems: 'center' }}
                >
                    <InputNumber<number> controls={false} addonAfter={unitName} />
                </Form.Item>
            )
        },
    },
    {
        title: 'Материал',
        children: [
            {
                title: 'Ширина',
                dataIndex: ['material', 'width'],
                width: 70,
            },

            {
                title: 'Тип',
                dataIndex: ['material', 'material_type', 'name'],
                width: 150,
            },
        ],
    },
]
